import { css } from '@emotion/core';
import { COLORS } from '../../globalStyle/colors';
import arrow from '../../assets/triangle-down.svg';


export const SELECT_GENERAL = css`
  height: 35px;
  border: 1px solid ${COLORS.LIGHT_GREY};
  color: ${COLORS.DARK_GREY};
  border-radius: 8px;
  padding: 0 12px;
  
  &:hover { 
    cursor: pointer;
  }

  & > option {
    color: ${COLORS.DARK_GREY};
  }

  &:invalid {
    color: ${COLORS.FIELD_GREY};
  }
  
  &:disabled {
    cursor: not-allowed;
  } 
`;

export const SELECT_ARROW = css`
  appearance: none;
  background-image: url(${arrow});
  background-repeat: no-repeat;
  
  &[dir="ltr"] {
    padding-right: 30px;
    background-position: right 12px center;
  }
  
  &[dir="rtl"] {
    padding-left: 30px;
    background-position: left 12px center;
  }

  &::-ms-expand {
    display: none;
  }
`;

export const SELECT = css`
  ${SELECT_GENERAL};
  ${SELECT_ARROW};
`;
